import { useState } from "react";
import { Link } from "react-router-dom";
import Photo from "../components/ui/Photo";
import { LOOKS, bySlug, categoryLatin, staffById } from "../data/salon";
import { useStagger } from "../lib/motion";
import PageHero from "../components/ui/PageHero";
import { useDocumentTitle } from "../lib/title";
import "./pages.css";

export default function Portfolio() {
  useDocumentTitle("نمونه‌کارها");
  const grid = useStagger({ step: 70 });
  const [open, setOpen] = useState(null);

  const look = open !== null ? LOOKS.find((l) => l.id === open) : null;
  const lookService = look ? bySlug(look.serviceSlug) : null;
  const lookStaff = look ? staffById(look.staffId) : null;

  return (
    <>
      <PageHero
        eyebrow="THE WORK"
        title="نمونه‌کارها"
        lede="کارهایی که در سالن انجام شده، با نام متخصصی که آن را اجرا کرده است."
        tone="#E0C089"
      />

      <section className="section">
        <div className="wrap wrap--wide">
          <div className="looks" ref={grid}>
            {LOOKS.map((l) => {
              const svc = bySlug(l.serviceSlug);
              const who = staffById(l.staffId);

              return (
                <button
                  key={l.id}
                  type="button"
                  className={`look reveal${l.span ? ` look--${l.span}` : ""}`}
                  data-stagger=""
                  style={{ "--tone": l.tone, "--tone2": l.tone2 }}
                  onClick={() => setOpen(l.id)}
                >
                  <Photo src={l.photo} alt={l.title} ratio="1 / 1" className="look__ph ph--hover" tint="dusk" />

                  <span className="look__meta">
                    <span className="look__title">{l.title}</span>
                    <span className="look__by">{who.name} · {svc.name}</span>
                  </span>

                  <span className="look__zoom" aria-hidden="true">↗</span>
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* -------------------------------------------------------- lightbox */}
      {look && (
        <div className="lbox" role="dialog" aria-modal="true" aria-label={look.title}>
          <button type="button" className="lbox__scrim" aria-label="بستن" onClick={() => setOpen(null)} />

          <div className="lbox__panel" style={{ "--tone": look.tone, "--tone2": look.tone2 }}>
            <button type="button" className="lbox__close" onClick={() => setOpen(null)} aria-label="بستن">✕</button>

            <div className="lbox__stage">
              <Photo src={look.photo} alt={look.title} ratio="3 / 4" />
            </div>

            <div className="lbox__body">
              <span className="eyebrow">{categoryLatin(lookService.category)}</span>
              <h2>{look.title}</h2>
              <p className="lbox__by">اجرا: {lookStaff.name} — {lookStaff.role}</p>
              <p>{lookService.short}</p>

              <Link to={`/services/${lookService.slug}`} className="btn" onClick={() => setOpen(null)}>
                رزرو همین خدمت
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
